// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HYu3","footer":"styles_footer__3emHK","passCodeTooltip":"styles_passCodeTooltip__1h-R6"};